import {FC} from 'react'
import Category from "../Options/Category";
import HjulskifteTireOfferTire from "./HjulskifteTireOfferTire";

interface Props {
    booking: Booking
    setBooking: Function,
    data: any
}

const HjulskifteTireOffer: FC<Props> = ({ booking, setBooking, data }) => {
    if(!data.rek.active)
        return
    console.log(data)
    return (
        <>
            <div dangerouslySetInnerHTML={data.rek.text} />
            <div className="wco-options">
                <div className="woocommerce tire-change-options_products">
                    <ul className="products">
                        {data.rek.tires.map((tire:any, i:number) => (
                            <HjulskifteTireOfferTire key={i} tireCount={data.customer.data.tireCount} booking={booking} setBooking={setBooking} data={tire}/>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    )
};

export default HjulskifteTireOffer